import React, { useEffect, useRef, useState } from "react";
import EditProduct from "./EditProduct";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useShowAlert } from "../../../context/AlertContext";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import Messages from "../../../constants/Messages";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import EditStock from "../stockbatch/EditStock";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import StockIn from "../stockbatch/StockIn";
import StockOut from "../stockbatch/StockOut";
import ProductSale from "./ProductSale";
import AddStockModel from "./AddStockModel";
import ProductDetails from "./ProductDetails";
import StockDetails from "./StockDetails";
import { toPrimaryQuantity } from "@heartinz/finance";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const ProductOverView = ({
  onClose,
  onData,
  onStockData,
  onUpdate,
  noteSuggests,
  isBtnLoading,
  setProductData,
  onStockEditData,
  OnStockTrashData,
  handleDeteleDataUpdate,
  brandSuggest,
  setBrandSuggest,
  onStockChanged,
}) => {
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [btnLoading, setBtnLoading] = useState(null);
  const showAlert = useShowAlert();
  const { checkNetwork } = useNetwork();
  const { isUser } = useAuth();
  const navigate = useNavigate();
  const {
    permission,
    storeSettings,
    hasPermission,
    hasModulePermission,
    blockedPermissions,
    viewOption,
  } = usePermission();
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data, setData] = useState(onData);
  const { useEscapeKey } = useContextApi();
  const [isStockEditModalOpen, setStockEditModalOpen] = useState(false);
  const [isStockInModalOpen, setStockInModalOpen] = useState(false);
  const [isStockEditData, setStockEditData] = useState([]);
  const [finalLandingCost, setFinalLandingCost] = useState([]);
  const [stockData, setStockData] = useState();
  const [isStockInData, setStockInData] = useState("");
  const [addStockOpen, setAddStocOpen] = useState(false);
  const [isStockOutModalOpen, setStockOutModalOpen] = useState(false);
  const [isStockOutData, setStockOutData] = useState("");
  const [minimumSalePrice, setMinimumSalePrice] = useState("");
  const [isMinimumPriceChanged, setIsMinimumPriceChanged] = useState(false);
  const minimumSalePriceRef = useRef(null);
  useEscapeKey(onClose);
  const [activeTab, setActiveTab] = useState("product");
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const primaryQuanity = (quanity, unitData) => {
    const qty = toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  };

  const closeEditStockModal = () => {
    setStockEditModalOpen(false);
    setStockEditData("");
  };

  const openAddStockModel = async (product) => {
    await getFinalLandingCost(
      product?.stockLinkId,
      product?.stockid,
      product?._id,
    );
    setAddStocOpen(true);
  };
  const getFinalLandingCost = async (stocklinkid, stockid, productid) => {
    try {
      if (!checkNetwork()) return;

      const params = new URLSearchParams();

      // always add productid
      params.append("productid", productid);

      // add stockid only if not null/undefined/empty
      if (stockid !== null && stockid !== undefined && stockid !== "") {
        params.append("stockid", stockid);
      }

      // add stocklinkid only if not null/undefined/empty
      if (
        stocklinkid !== null &&
        stocklinkid !== undefined &&
        stocklinkid !== ""
      ) {
        params.append("stocklinkid", stocklinkid);
      }

      const response = await AxiosInstance.get(
        `module/stock/final-landingcost?${params.toString()}`,
      );
      // const response = await AxiosInstance.get(`module/stock/final-landingcost?${stocklinkid}
      // &stockid=${stockid}&productid=${productid}`);
      setFinalLandingCost(response.data?.results?.finalLandingCost);
      return response.data?.results?.finalLandingCost;
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  const closeAddStockModel = () => {
    setAddStocOpen(false);
  };
  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem.landingcost || 0,
          "INR",
        ),
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openEditStcokModal = (cItem, cIndex) => {
    if (hasPermission("STOCK", "STOCK:update") || permission === undefined) {
      const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
      setStockEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(cItem.landingcost, "INR"),
        manufacturedate: isValidDate(cItem.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        expiredate: isValidDate(cItem.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        cIndex: cIndex,
      });
      setStockEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdate = async (updatedData, imageFile, trigger = true) => {
    const success = await onUpdate(updatedData, imageFile, trigger);
    if (!success) return;
    setProductData((prevProductData) =>
      prevProductData?.map((product) =>
        product?._id === updatedData?._id ? updatedData : product,
      ),
    );
    setData((prevProductData) =>
      prevProductData?._id === updatedData?._id
        ? { ...updatedData, updated: true }
        : { ...prevProductData, updated: true },
    );
    if (updatedData) {
      closeEditModal();
    }
  };

  const handleStockUpdate = async (updatedData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        // stockid: updatedData._id,
        ...(updatedData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            updatedData?.manufacturedate,
            isUser.timezone,
          ),
        }),
        ...(updatedData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            updatedData?.expiredate,
            isUser.timezone,
          ),
        }),
        mrp: CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
        taxpercentage: Number(updatedData?.taxpercentage),
        // discount: CurrencyConverter.toSubunit(updatedData.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(updatedData.taxamount, "INR"),
        isLock: updatedData.isLock,
        landingcost: CurrencyConverter.toSubunit(
          updatedData.landingcost || 0,
          "INR",
        ),
      };
      const response = await AxiosInstance.patch(
        `module/stock/${updatedData?.stockid}`,
        data,
      );
      var index = updatedData.cIndex;
      const updatedDatas = response.data.results;

      const updatedStock = {
        ...updatedData, // preserve UI fields
        ...updatedDatas, // overwrite with latest API values
        mrp: updatedDatas.mrp,
        saleprice: updatedDatas.saleprice,
        baseprice: updatedDatas.baseprice,
        taxamount: updatedDatas.taxamount,
        taxpercentage: updatedDatas.taxpercentage,
        landingcost: updatedDatas.landingcost,
        isLock: updatedDatas.isLock,
      };

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedDatas?.stockLinkId
            ? { ...item, ...updatedDatas, _id: updatedDatas.stockLinkId }
            : item,
        ),
      );

      const stockValue = updatedData?.isSecondaryUnit
        ? primaryQuanity(updatedData?.stock || 0, updatedData?.unitConfig)
        : updatedData?.stock || 0;

      if (stockValue > 0.0) {
        if (updatedData?.stockLeft < stockValue) {
          await handleStockInUpdate(updatedData);
        } else if (updatedData?.stockLeft >= stockValue) {
          if (updatedData?.stockLeft >= stockValue) {
            await handleStockTrashUpdate(updatedData);
          } else {
            console.log("insufficient Stock");
          }
        } else {
          console.log("euql");
        }
      }
      // setRecentStock((perv)=>{
      // const savedStocks = JSON.parse(localStorage.getItem("recentStocks")) || [];
      //   const updatedStocks = savedStocks.map((item) =>
      //   item.productid === updatedData.productid
      //       ? { ...item, ...updatedData }
      //       : item
      //   );
      //   localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      //   return updatedStocks;
      // })
      onStockEditData(updatedStock);
      await onStockChanged?.();
      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeEditStockModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockInUpdate = async (updatedData, quantity) => {
    // console.log(updatedData);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        // stockid: updatedData._id,
        stocklinkid: updatedData?.stockLinkId,
        // ...(updatedData?.stock===0
        // ? { quantity: quantity }
        // : { quantity: updatedData?.stock - updatedData?.stockLeft }),
        quantity: Number(
          updatedData?.isSecondaryUnit
            ? (
                primaryQuanity(updatedData?.stock, updatedData?.unitConfig) -
                updatedData?.stockLeft
              ).toFixed(3)
            : (updatedData?.stock - updatedData?.stockLeft).toFixed(3),
        ),
        // quantity: quantity,
      };
      const response = await AxiosInstance.patch(
        `module/stock/stockin/${updatedData?.stockid}`,
        data,
      );
      var index = updatedData?.cIndex;
      const updatedDatas = response.data.results;
      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedDatas?._id
            ? {
                ...item,
                stockIn: updatedDatas?.stockIn,
                stockLeft: updatedDatas?.stockLeft,
              }
            : item,
        ),
      );
      onStockEditData(
        updatedDatas,
        stockData,
        updatedData?.stock - updatedData?.stockLeft,
      );
      await onStockChanged?.();
      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockInModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockIn = async (updatedData, quantity) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        // stockid: updatedData._id,
        stocklinkid: updatedData?.stockLinkId,
        quantity: quantity,
      };
      const response = await AxiosInstance.patch(
        `module/stock/stockin/${updatedData?.stockid}`,
        data,
      );
      var index = updatedData?.cIndex;
      updatedData = response.data.results;
      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedData?._id
            ? {
                ...item,
                stockIn: updatedData?.stockIn,
                stockLeft: updatedData?.stockLeft,
              }
            : item,
        ),
      );
      onStockEditData(updatedData, stockData, quantity);
      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockInModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleAddDirct = async (newStockData, quantity) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        stocklinkid: newStockData.stockLinkId,
        quantity: quantity,
        landingcost: CurrencyConverter.toSubunit(
          newStockData.landingcost || 0,
          "INR",
        ),
      };
      const response = await AxiosInstance.post(`module/stock/direct`, data);
      showAlert("success", Messages.SUCCESS.STOCK_ADDED);
      const result = response.data.results;
      const updatedStock = {
        ...result,
        stockIn: result.stockIn,
        stockLeft: result.stockLeft,
        title: newStockData?.title,
        code: newStockData?.code,
        saleprice: CurrencyConverter.toSubunit(newStockData.saleprice, "INR"),
        taxpercentage: newStockData.taxpercentage,
        landingcost: result.landingcost,
        stockid: result.stockid,
        productid: result.productid,
        stocklinkid: newStockData.stockLinkId,
      };
      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockid === result?.stockid
            ? {
                ...item,
                stockIn: item.stockIn + result?.stockIn,
                stockLeft: result?.stockLeft,
                title: newStockData?.title,
                code: newStockData?.code,
                taxpercentage: newStockData.taxpercentage,
                landingcost: result.landingcost,
                stockid: result.stockid,
                productid: result.productid,
                stocklinkid: newStockData.stockLinkId,
              }
            : item,
        ),
      );
      onStockEditData(updatedStock, stockData, quantity);
      await onStockChanged?.();
      closeStockInModal();
      const previousStocks =
        JSON.parse(localStorage.getItem("recentDirectStocks")) || [];

      const updatedStocks = [updatedStock, ...previousStocks].slice(0, 10); // Store only latest 10

      localStorage.setItem("recentDirectStocks", JSON.stringify(updatedStocks));
      // ListRecentStock();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockTrashUpdate = async (updatedData, quantity, remarks) => {
    // console.log("trash", updatedData);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        stockid: updatedData?.stockid,
        // stocklid: updatedData.stocklid,
        ...(remarks && { remarks }),
        remarks: "Stock Trashed",
        // quantity: quantity,
        quantity: Number(
          updatedData?.isSecondaryUnit
            ? (
                updatedData.stockLeft -
                primaryQuanity(updatedData?.stock, updatedData?.unitConfig)
              ).toFixed(3)
            : (updatedData.stockLeft - updatedData?.stock).toFixed(3),
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData?.stockLinkId}`,
        { data },
      );
      var index = updatedData?.cIndex;
      const updatedDatas = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedDatas?.stockLinkId
            ? {
                ...item,
                stockLeft: Number(
                  (item?.stockLeft - updatedDatas?.quantity).toFixed(3),
                ),
              }
            : item,
        ),
      );
      OnStockTrashData(
        updatedDatas,
        stockData,
        updatedData.stockLeft - updatedData?.stock,
      );
      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockTrash = async (
    updatedData,
    quantity,
    remarks,
    selectedUnit,
  ) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        stockid: updatedData?.stockid,
        // stocklid: updatedData.stocklid,
        ...(remarks && { remarks }),
        // quantity: quantity,
        // quantity:Number(updatedData?.isSecondaryUnit?primaryQuanity(quantity,updatedData?.unitConfig):quantity)
        quantity: Number(
          updatedData?.isSecondaryUnit &&
            selectedUnit === updatedData?.unitConfig?.secondaryUnitCode
            ? primaryQuanity(quantity, updatedData?.unitConfig)
            : quantity,
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData?.stockLinkId}`,
        { data },
      );
      var index = updatedData?.cIndex;
      updatedData = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedData?.stockLinkId
            ? {
                ...item,
                stockLeft: Number(
                  (item?.stockLeft - updatedData?.quantity).toFixed(3),
                ),
              }
            : item,
        ),
      );
      OnStockTrashData(updatedData, stockData, quantity);
      showAlert("success", Messages.SUCCESS.STOCK_TRASHED);
      closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeStockInModal = () => {
    setStockInModalOpen(false);
    setStockInData("");
  };

  const handleMinimumSalePriceSave = () => {
    handleUpdate({
      ...data,
      minimumSalePrice: minimumSalePrice,
    });

    setIsMinimumPriceChanged(false);
  };

  const openStockInModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:updateStockin") ||
      permission === undefined
    ) {
      setStockInModalOpen(true);
      cItem.cIndex = index;
      setStockInData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async (isDeleteData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = { productid: isDeleteData._id };
      await AxiosInstance.delete(
        `module/product/delete-product/${isDeleteData._id}`,
      );
      showAlert("success", Messages.SUCCESS.PRODUCT_DELETED);
      onClose();
      handleDeteleDataUpdate();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockAdd = async (
    newStockData,
    selectedProduct,
    resetForm,
    selectedUnit,
  ) => {
    const isSecondaryUnit = () => {
      if (newStockData?.unitConfig?.primaryUnitCode === selectedUnit) {
        return false;
      } else if (newStockData?.unitConfig?.secondaryUnitCode === selectedUnit) {
        return true;
      } else {
        return false;
      }
    };
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: selectedProduct._id,
        ...(newStockData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            newStockData?.manufacturedate,
            isUser?.timezone,
          ),
        }),
        ...(newStockData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            newStockData?.expiredate,
            isUser?.timezone,
          ),
        }),
        mrp: newStockData.mrp,
        saleprice: newStockData.saleprice,
        taxpercentage: newStockData.taxpercentage,
        baseprice: newStockData.baseprice,
        landingcost: CurrencyConverter.toSubunit(
          newStockData.landingcost || 0,
          "INR",
        ),
        isLock: newStockData.isLock,
        // quantity:Number(newStockData.quantity),
        quantity: Number(
          isSecondaryUnit()
            ? primaryQuanity(
                newStockData?.quantity || 0,
                newStockData?.unitConfig,
              )
            : newStockData?.quantity || 0,
        ),
        isSecondaryUnit: isSecondaryUnit(),
      };
      const response = await AxiosInstance.post(`module/stock`, data);
      showAlert("success", Messages.SUCCESS.STOCK_ADDED);
      const result = response.data.results;
      await onStockChanged?.(result);
      resetForm();
      closeAddStockModel();
      const updatedStock = {
        ...result,
        title: selectedProduct?.title,
        code: selectedProduct?.code,
        stockid: result._id,
        stockLeftUnit: result?.unitConfig?.primaryUnitCode,
      };
      handleupdateListStock(updatedStock);
      const previousStocks =
        JSON.parse(localStorage.getItem("recentStocks")) || [];

      const updatedStocks = [updatedStock, ...previousStocks].slice(0, 10);

      localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      // ListRecentStock();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleCreateStock = async (
    newStockData,
    selectedProduct,
    resetForm,
    selectedUnit,
  ) => {
    const isSecondaryUnit = () => {
      if (newStockData?.unitConfig?.primaryUnitCode === selectedUnit) {
        return false;
      } else if (newStockData?.unitConfig?.secondaryUnitCode === selectedUnit) {
        return true;
      } else {
        return false;
      }
    };
    if (
      blockedPermissions("STOCK:createAndAddDirect") ||
      permission === undefined
    ) {
      setBtnLoading(true);
      try {
        if (!checkNetwork()) return;
        const data = {
          productid: selectedProduct._id,
          ...(newStockData?.manufacturedate && {
            manufacturedate: DateConverter.convertToTimeZone(
              newStockData?.manufacturedate,
              isUser?.timezone,
            ),
          }),
          ...(newStockData?.expiredate && {
            expiredate: DateConverter.convertToTimeZone(
              newStockData?.expiredate,
              isUser?.timezone,
            ),
          }),
          mrp: newStockData.mrp,
          saleprice: newStockData.saleprice,
          taxpercentage: newStockData.taxpercentage,
          discount: newStockData.discount,
          baseprice: newStockData.baseprice,
          taxamount: newStockData.taxamount,
          landingcost: CurrencyConverter.toSubunit(
            newStockData.landingcost || 0,
            "INR",
          ),
          isLock: newStockData.isLock,
          quantity: Number(
            isSecondaryUnit()
              ? primaryQuanity(
                  newStockData?.quantity || 0,
                  newStockData?.unitConfig,
                )
              : newStockData?.quantity || 0,
          ),
          isSecondaryUnit: isSecondaryUnit(),
        };

        const response = await AxiosInstance.post(
          `module/stock/create-add-direct`,
          data,
        );
        // onUpdate()
        showAlert("success", Messages.SUCCESS.STOCK_ADDED);
        const result = response.data.results;
        const updatedStock = {
          ...result,
          title: selectedProduct?.title,
          code: selectedProduct?.code,
          mrp: data?.mrp,
          saleprice: data?.saleprice,
          taxpercentage: data?.taxpercentage,
          stockid: result.stockid,
          manufacturedate: data?.manufacturedate,
          expiredate: data?.expiredate,
          stockLinkId: result?._id,
        };
        handleupdateListStock(updatedStock);
        resetForm();
        closeAddStockModel();
        await onStockChanged?.();
      } catch (error) {
        handleError(error, showAlert);
        return false;
      } finally {
        setBtnLoading(false);
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeStockOutModal = () => {
    setStockOutModalOpen(false);
    setStockOutData("");
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleAddStock = () => {
    if (isUser.stype === "MAIN") {
      navigate("/stock", { state: { data } });
    } else {
      navigate("/substock", { state: { data } });
    }
  };
  // useEffect(() => {
  //   if (onData) {
  //     setData(onData);
  //   }
  // }, [onData]);

  useEffect(() => {
    if (onStockData) {
      setStockData(onStockData);
    }
  }, [onStockData]);
  const handleupdateListStock = (onlistData) => {
    setStockData((prev) => [
      { ...onlistData, stockLeft: onlistData.stockIn },
      ...(Array.isArray(prev) ? prev : []),
    ]);
    onStockEditData(onlistData, stockData, onlistData.stockIn);
  };

  useEffect(() => {
    if (onData) {
      setData(onData);
    }
  }, [onData]);

  useEffect(() => {
    if (onData) {
      const value = onData?.minimumSalePrice
        ? CurrencyConverter.toCurrency(onData.minimumSalePrice, "INR")
        : "";

      setMinimumSalePrice(value);
      setIsMinimumPriceChanged(false);
    }
  }, [onData]);

  useEffect(() => {
    if (activeTab === "advanced") {
      minimumSalePriceRef.current?.focus();
      minimumSalePriceRef.current?.select();
    }
  }, [activeTab]);
  // useEffect(() => {
  //   const handleArrowAndEnter = (e) => {
  //     if(isEditModalOpen) return;
  //     if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

  //     e.preventDefault();

  //     const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
  //     if (!tableRows.length) return;

  //     const currentRow = document.activeElement.closest("tr");
  //     let currentIndex = tableRows.indexOf(currentRow);

  //     // Handle Enter key
  //     if (e.key === "Enter") {
  //       if (currentIndex >= 0) {
  //         const item = tableRows[currentIndex].dataset.item
  //           ? JSON.parse(tableRows[currentIndex].dataset.item)
  //           : null;

  //         if (item){
  //           if (isUser.stype === "MAIN") {
  //             openEditStcokModal(item,currentIndex);
  //           } else {
  //             openDeleteTrashModal(item,currentIndex);
  //           }
  //         }
  //       }
  //       return;
  //     }

  //     // Virtual -1: no row focused yet
  //     if (currentIndex === -1) {
  //       if (e.key === "ArrowDown") {
  //         tableRows[0].tabIndex = 0;
  //         tableRows[0].focus();
  //       } else if (e.key === "ArrowUp") {
  //         tableRows[tableRows.length - 1].tabIndex = 0;
  //         tableRows[tableRows.length - 1].focus();
  //       }
  //       return;
  //     }

  //     // Remove tabIndex from current row
  //     currentRow.tabIndex = -1;

  //     // Calculate next/previous index
  //     let nextIndex =
  //       e.key === "ArrowDown"
  //         ? (currentIndex + 1) % tableRows.length
  //         : (currentIndex - 1 + tableRows.length) % tableRows.length;

  //     const nextRow = tableRows[nextIndex];
  //     nextRow.tabIndex = 0;
  //     nextRow.focus();
  //   };

  //   window.addEventListener("keydown", handleArrowAndEnter);
  //   return () => window.removeEventListener("keydown", handleArrowAndEnter);
  // }, [isEditModalOpen]);
  return (
    <div className="modal-overlay" style={{ zIndex: 1010 }}>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog  modal-xl  modal-dialog-scrollable">
          <div
            className="modal-content height-xl"
            style={{ minHeight: "500px" }}
          >
            <div className="modal-header">
              <div className="d-flex align-items-center text-center modal-title pe-3">
                Product View{" "}
                {/* <div className="text-center ms-2">
                  <span className="badge rounded-pill bg-label-navy">
                    {data?.code}{" "}
                  </span>
                  &nbsp;- {data?.title}
                </div> */}
              </div>
              <div className="d-flex align-items-center fw-bold text-dark mb-0 ms-auto me-2">
                {/* <button
                  type="button"
                  className="btn btn-label-primary shadow-none  me-4 py-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    openEditModal(data);
                  }}
                >
                  <i className="ng ng-ng-edit-icon me-1 "></i>Edit
                </button> */}
                <button
                  type="button"
                  className="btn-close border"
                  onClick={onClose}
                ></button>
              </div>
            </div>
            <div className="modal-body" style={{ backgroundColor: "#ebf5ff" }}>
              {/* <div
                className="border-bottom mb-2"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  scrollbarWidth: "thin", // Firefox
                }}
              >
                <ul
                  className="nav d-flex align-items-center px-1 m-0"
                  style={{
                    flexWrap: "nowrap",
                    gap: "10px",
                    minHeight: "40px",
                    listStyle: "none",
                  }}
                >
                  {[
                    ...(hasModulePermission("PRODUCT") ||
                    permission === undefined
                      ? [
                          {
                            id: "product",
                            label: "Product Details",
                            icon: "ng ng-ng-product-icon",
                          },
                        ]
                      : []),
                    ...(hasModulePermission("STOCK") || permission === undefined
                      ? [
                          {
                            id: "stock",
                            label: "Stock Details",
                            icon: "ng ng-ng-stock-icon",
                          },
                        ]
                      : []),
                    // ...(hasModulePermission("REPORT") || permission === undefined) ? [
                    // {
                    //   id: "sale",
                    //   label: "Sale Details",
                    //   icon: "ng ng-ng-negobill_icon",
                    // }]:[],
                  ].map((tab) => (
                    <li
                      key={tab.id}
                      className="nav-item"
                      style={{
                        borderBottom:
                          activeTab === tab.id
                            ? "3px solid #007bff"
                            : "3px solid transparent",
                        transition: "all 0.2s ease-in-out",
                        flex: "0 0 auto",
                      }}
                    >
                      <button
                        onClick={() => setActiveTab(tab.id)}
                        className={`nav-link fw-semibold ${
                          activeTab === tab.id ? "text-primary" : "text-muted"
                        }`}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "6px 10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className={`${tab.icon}`}></i>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div> */}
              <div
                className="border-bottom mb-2"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  scrollbarWidth: "thin", // Firefox
                }}
              >
                <ul
                  className="nav d-flex align-items-center px-1 m-0"
                  style={{
                    flexWrap: "nowrap",
                    gap: "10px",
                    minHeight: "40px",
                    listStyle: "none",
                  }}
                >
                  {[
                    {
                      id: "product",
                      label: "Product View",
                      icon: "ng ng-ng-product-icon",
                    },
                    {
                      id: "advanced",
                      label: "Advanced Settings",
                      icon: "bx bx-cog",
                    },
                  ].map((tab) => (
                    <li
                      key={tab.id}
                      className="nav-item"
                      style={{
                        borderBottom:
                          activeTab === tab.id
                            ? "3px solid #007bff"
                            : "3px solid transparent",
                        transition: "all 0.2s ease-in-out",
                        flex: "0 0 auto",
                      }}
                    >
                      <button
                        onClick={() => setActiveTab(tab.id)}
                        className={`nav-link fw-semibold ${
                          activeTab === tab.id ? "text-primary" : "text-muted"
                        }`}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "6px 10px",
                          fontSize: "0.9rem",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className={`${tab.icon}`}></i>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              {activeTab === "product" && (
                <ProductDetails
                  data={data}
                  onClose={closeEditModal}
                  onEdit={handleUpdate}
                  btnLoading={btnLoading}
                  isBtnLoading={isBtnLoading}
                  noteSuggests={noteSuggests}
                  isEditModalOpen={isEditModalOpen}
                  setEditModalOpen={setEditModalOpen}
                  setDeleteModalOpen={setDeleteModalOpen}
                  handleDelete={handleDelete}
                  isDeleteModalOpen={isDeleteModalOpen}
                  brandSuggest={brandSuggest}
                  setBrandSuggest={setBrandSuggest}
                  isStockEditModalOpen={isStockEditModalOpen}
                  closeEditStockModal={closeEditStockModal}
                  handleStockUpdate={handleStockUpdate}
                  setStockEditModalOpen={setStockEditModalOpen}
                  stockData={stockData}
                  setStockOutModalOpen={setStockOutModalOpen}
                  setAddStocOpen={setAddStocOpen}
                  addStockOpen={addStockOpen}
                  closeAddStockModel={closeAddStockModel}
                  handleupdateListStock={handleupdateListStock}
                  handleStockAdd={handleStockAdd}
                  handleCreateStock={handleCreateStock}
                  isStockOutModalOpen={isStockOutModalOpen}
                  closeStockOutModal={closeStockOutModal}
                  handleStockTrash={handleStockTrash}
                />
              )}
              {activeTab === "advanced" && (
                <div className="row">
                  {storeSettings?.productSettings?.advanceSettings
                    ?.isMinimumSalePrice && (
                    <div className="col-md-5">
                      <div className="card shadow-sm border-0">
                        <div className="card-body">
                          {/* <h6 className="mb-3">Pricing</h6> */}

                          {/* <div className="d-flex justify-content-between mb-3">
                          <span className="text-muted">Sale Price</span>
                          <span className="badge bg-label-success">
                            ₹
                            {CurrencyConverter.toCurrency(
                              data?.saleprice || 0,
                              "INR",
                            )}
                          </span>
                        </div> */}

                          <div className="col-lg-6">
                            <label className="form-label fw-medium">
                              Minimum Sale Price
                            </label>

                            <div className="position-relative">
                              <input
                                ref={minimumSalePriceRef}
                                type="text"
                                className="form-control pe-5"
                                placeholder="Enter Minimum Sale Price"
                                value={minimumSalePrice}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  if (value === "") {
                                    setMinimumSalePrice("");
                                    setIsMinimumPriceChanged(true);
                                    return;
                                  }

                                  const amount = Number(value);
                                  const salePrice = Number(
                                    CurrencyConverter.toCurrency(
                                      data?.saleprice || 0,
                                      "INR",
                                    ),
                                  );

                                  if (amount > salePrice) {
                                    showAlert(
                                      "warning",
                                      `Minimum Sale Price cannot be greater than ₹${salePrice}`,
                                    );
                                    return;
                                  }

                                  setMinimumSalePrice(value);

                                  setIsMinimumPriceChanged(
                                    value !==
                                      String(
                                        CurrencyConverter.toCurrency(
                                          data?.minimumSalePrice || 0,
                                          "INR",
                                        ),
                                      ),
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Enter" &&
                                    isMinimumPriceChanged
                                  ) {
                                    e.preventDefault();
                                    handleMinimumSalePriceSave();
                                  }
                                }}
                              />

                              {isMinimumPriceChanged && (
                                <button
                                  type="button"
                                  className="btn btn-label-success btn-sm position-absolute top-50 end-0 translate-middle-y me-2 p-1 shadow-none"
                                  onClick={handleMinimumSalePriceSave}
                                >
                                  <CheckIcon iClass={"fs-5"}/>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {activeTab === "stock" &&
                (hasModulePermission("STOCK") || permission === undefined) && (
                  <StockDetails
                    stockData={stockData}
                    onData={data}
                    closeEditStockModal={closeEditStockModal}
                    handleStockUpdate={handleStockUpdate}
                    isStockEditModalOpen={isStockEditModalOpen}
                    setStockEditModalOpen={setStockEditModalOpen}
                    isStockInModalOpen={isStockInModalOpen}
                    closeStockInModal={closeStockInModal}
                    setStockInModalOpen={setStockInModalOpen}
                    handleStockIn={handleStockIn}
                    isStockOutModalOpen={isStockOutModalOpen}
                    closeStockOutModal={closeStockOutModal}
                    handleStockTrash={handleStockTrash}
                    setStockOutModalOpen={setStockOutModalOpen}
                    addStockOpen={addStockOpen}
                    closeAddStockModel={closeAddStockModel}
                    handleupdateListStock={handleupdateListStock}
                    handleStockAdd={handleStockAdd}
                    handleCreateStock={handleCreateStock}
                    setAddStocOpen={setAddStocOpen}
                    btnLoading={btnLoading}
                  />
                  // <>
                  //   <div className="d-block d-flex justify-content-between mb-2">
                  //     <div></div>

                  //     <div>
                  //       <button
                  //         onClick={() => openAddStockModel(data)}
                  //         type="button"
                  //         className="btn btn-teal text-right"
                  //       >
                  //         <i className="ng ng-ng-stock-add-icon"></i> Add Stock
                  //       </button>
                  //     </div>
                  //   </div>
                  //   <div className="table-responsive">
                  //     <table className="table align-middle mb-0">
                  //       <thead className="table-light">
                  //         <tr>
                  //           <th className="text-center">MRP</th>
                  //           <th className="text-center">Sale Price</th>
                  //           <th className="text-center">Tax(%)</th>
                  //           <th className="text-center">LandingCost</th>
                  //           {viewOption(
                  //             "stockSettings",
                  //             "isManufactureAndExpiryDates"
                  //           ) && <th className="text-center ">Date</th>}
                  //           <th className="text-center ">Stock Left</th>
                  //           <th className="text-center">Action</th>
                  //         </tr>
                  //       </thead>
                  //       <tbody>
                  //         {stockData?.length > 0 ? (
                  //           stockData?.map((item, index) => (
                  //             <tr
                  //               key={index}
                  //               className="position-relative  cursor-poInter hover-row"
                  //               onClick={() => {
                  //                 if (isUser.stype === "MAIN") {
                  //                   openEditStcokModal(item, index);
                  //                 } else {
                  //                   openDeleteTrashModal(item, index);
                  //                 }
                  //               }}
                  //               data-item={JSON.stringify(item)}
                  //             >
                  //               <td className="text-center">
                  //                 <span className="badge bg-label-fall rounded-pill">
                  //                   ₹
                  //                   {CurrencyConverter.toCurrency(
                  //                     item?.mrp || 0,
                  //                     "INR"
                  //                   )}
                  //                 </span>
                  //               </td>
                  //               <td className="text-center">
                  //                 <span className="badge bg-label-food rounded-pill">
                  //                   ₹
                  //                   {CurrencyConverter.toCurrency(
                  //                     item?.saleprice || 0,
                  //                     "INR"
                  //                   )}
                  //                 </span>
                  //               </td>
                  //               <td className="text-center">
                  //                 <span className="badge rounded-pill bg-label-peace">
                  //                   {item.taxpercentage}%
                  //                 </span>
                  //               </td>
                  //               <td className="text-center">
                  //                 <span className="badge bg-label-secondary rounded-pill">
                  //                   ₹
                  //                   {CurrencyConverter.toCurrency(
                  //                     item?.landingcost || 0,
                  //                     "INR"
                  //                   )}
                  //                 </span>
                  //               </td>
                  //               {viewOption(
                  //                 "stockSettings",
                  //                 "isManufactureAndExpiryDates"
                  //               ) && (
                  //                 <td className="text-center">
                  //                   <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                  //                     MFD :{" "}
                  //                     {item?.manufacturedate
                  //                       ? DateConverter.ISOToDisplayFormat(
                  //                           DateConverter.convertToTimeZone(
                  //                             item?.manufacturedate,
                  //                             isUser.timezone
                  //                           )
                  //                         ).date
                  //                       : ""}
                  //                   </small>
                  //                   <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                  //                     EXP :{" "}
                  //                     {item?.expiredate
                  //                       ? DateConverter.ISOToDisplayFormat(
                  //                           item.expiredate,
                  //                           isUser.timezone
                  //                         ).date
                  //                       : ""}
                  //                   </small>
                  //                 </td>
                  //               )}
                  //               <td className="text-center">
                  //                 <span className="badge bg-label-space mx-1">
                  //                   {item.stockLeft}
                  //                 </span>
                  //                 /{" "}
                  //                 <span className="badge bg-label-spring">
                  //                   {item.stockIn}
                  //                 </span>
                  //               </td>
                  //               <td className="text-center">
                  //                 <div className="order-actions1">
                  //                   {isUser.stype === "MAIN" && (
                  //                     <>
                  //                       <button
                  //                         type="button"
                  //                         className="btn btn-sm btn-label-teal  shadow-none me-2"
                  //                         onClick={(e) => {
                  //                           e.stopPropagation();
                  //                           openEditStcokModal(item, index);
                  //                         }}
                  //                       >
                  //                         <i className="ng ng-ng-edit-icon"></i>
                  //                       </button>
                  //                     </>
                  //                   )}
                  //                   <button
                  //                     type="button"
                  //                     className="btn btn-sm btn-label-teal  shadow-none me-2 "
                  //                     onClick={(e) => {
                  //                       e.stopPropagation();
                  //                       openStockInModal(item, index);
                  //                     }}
                  //                   >
                  //                     <i className="ng ng-ng-add-icon"></i>{" "}
                  //                     Stock
                  //                   </button>
                  //                   <button
                  //                     type="button"
                  //                     className="btn btn-sm btn-label-danger shadow-none"
                  //                     onClick={(e) => {
                  //                       e.stopPropagation();
                  //                       openDeleteTrashModal(item, index);
                  //                     }}
                  //                   >
                  //                     <i className="ng ng-ng-delete-icon"></i>
                  //                   </button>
                  //                 </div>
                  //               </td>
                  //             </tr>
                  //           ))
                  //         ) : (
                  //           <tr>
                  //             <td colSpan={7} className="text-center">
                  //               No Stock Data Found!
                  //             </td>
                  //           </tr>
                  //         )}
                  //       </tbody>
                  //     </table>
                  //   </div>
                  // </>
                )}
              {activeTab === "sale" && <ProductSale productId={data._id} />}
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon iClass={"fs-15"}/> Close
              </button>
              {/* <button
                onClick={handleAdd}
                ref={handleUpdateRef}
                type="button"
                className="btn btn-teal text-right"
              >
                <i className="ng ng-ng-add-icon"></i> Add
              </button> */}
            </div>
          </div>
        </div>
      </div>
      {/* {isEditModalOpen && (
        <EditProduct
          editData={isEditData}
          onClose={closeEditModal}
          onEdit={handleUpdate}
          isBtnLoading={isBtnLoading}
          noteSuggests={noteSuggests}
        />
      )} */}
      {/* {isStockEditModalOpen && (
        <EditStock
          editData={isStockEditData}
          onClose={closeEditStockModal}
          onEdit={handleStockUpdate}
          isBtnLoading={btnLoading}
        />
      )} */}
      {/* {isStockInModalOpen && (
        <StockIn
          data={isStockInData}
          onClose={closeStockInModal}
          onEdit={handleStockIn}
          isBtnLoading={isBtnLoading}
        />
      )} */}
      {/* {isStockOutModalOpen && (
        <StockOut
          data={isStockOutData}
          onClose={closeStockOutModal}
          onEdit={handleStockTrash}
          isBtnLoading={isBtnLoading}
        />
      )} */}
      {/* {addStockOpen && (
        <AddStockModel
          onclose={closeAddStockModel}
          onData={data}
          stokData={stockData}
          onUpdate={handleupdateListStock}
          onStockAdd={handleStockAdd}
          onStockCreate={handleCreateStock}
          finalLand={finalLandingCost}
        />
      )} */}
    </div>
  );
};

export default ProductOverView;
